import React, {useEffect,useRef} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import AutosizeInput from 'react-input-autosize';
import fuzzer from '../../../utils/fuzzer';
import {input} from "../../../utils/linker";
import reactionCombiner from "../../../utils/reactionCombiner";
import TagInSearch from "./TagInSearch";
import TagInRow from "./TagInRow";
import Portal from "../Portal";

function Taglist(props) {
  const store = useLocalObservable(() => ({
    focused:false,
    blurTa:null,
    input_value:'',
    selected:-1,
    filtered_list:[],
    combiner:null
  }));
  let _inputRef;
  let _scrollerRef = useRef(null);
  let _fakeInputRef=useRef(null);
  useEffect(() => {
    // mount
    if(!props.single &&!Array.isArray(props.linker.value)) {
      runInAction(() => {
        props.linker.value = [];
      });
    }
    if(!store.combiner) {
      store.combiner=new reactionCombiner();
      store.combiner.addReaction(()=>{
        return store.input_value;
      },()=> {
        runInAction(()=>{
          if(store.input_value) {
            store.filtered_list = fuzzer(
              {data:props.fullList},
              store.input_value,
              {
                key: props.visible.map((item)=>{ return { key:item, weight: 4 }; }),
                usePathScoring: true,
              }
            );
          } else {
            store.filtered_list=props.fullList;
          }
        });
      }, { fireImmediately:true });
    }
    return () => {
      // unmount
      store.combiner.clear();
    }
  }, []);

  const scrollToIfNotVisible=(scrollerOb,itemOb)=>{
    const rect = scrollerOb.getBoundingClientRect();
    const rectScrollTop = scrollerOb.scrollTop;
    const height = scrollerOb.clientHeight;
    const itemRect = itemOb.getBoundingClientRect();
    const diff = itemRect.y - rect.y;
    if(diff<0 || diff+itemOb.clientHeight > scrollerOb.clientHeight) {
      const relPos = diff + rectScrollTop;
      scrollerOb.scrollTop = relPos - (height / 2) + (itemOb.clientHeight/2);
    }
  }

  const onFocus=()=>{
    clearTimeout(store.blurTa);
    runInAction(()=>{
      store.focused=true;
    });
  };
  const onBlur=()=>{
    store.blurTa=setTimeout(()=>{
      runInAction(()=>{
        store.focused=false
      });
    },100)
  };

  const deleteLastTag=()=>{
    runInAction(()=>{
      if(props.single) {
        props.linker.value=null;
      } else {
        if (props.linker.value.length) {
          props.linker.value.splice(props.linker.value.length - 1, 1);
        }
      }
    });
  };
  const selectTag=(overrideSelected)=>{
    runInAction(()=> {
      const selectedTag=store.filtered_list[typeof overrideSelected !== "undefined" ? overrideSelected : store.selected];
      if (selectedTag) {
        if(props.single) {
          props.linker.value=selectedTag[props.selected_code];
          store.input_value='';
        } else {
          if (!props.linker.value.filter((item) => {
            return item === selectedTag[props.selected_code];
          }).length) {
            props.linker.value.push(selectedTag[props.selected_code]);
          }
        }
      }
    });
  };

  const keyDown=(e)=>{
    const keyId=e.which;
    //up 38, down 40, enter 13
    let setSelected='not_set';
    switch(keyId) {
      case 27: //up
        // onBlur();
        _inputRef.blur();
      case 38: //up
        setSelected=store.selected-1;
        break;
      case 40: //down
        setSelected=store.selected+1;
        break;
      case 13: //enter
        selectTag();
        break;
      case 8://backspace
        if(!store.input_value) {
          deleteLastTag();
        }
        break;
    }
    if(setSelected!=="not_set") {
      if (setSelected > (store.filtered_list.length-1)) {
        setSelected = 0;
      }
      if (setSelected < 0) {
        setSelected = store.filtered_list.length-1;
      }
      setTimeout(()=>{

      },50);
      runInAction(() => {
        store.selected=setSelected;
      })
    }
  };

  const renderList=()=>{
    const iReturn=[];
    if(store.filtered_list.length) {
      for(let i in store.filtered_list) {
        iReturn.push(
          <TagInSearch key={i} selectMe={()=>{ selectTag(i); }} selected={store.selected == i} key={i} item={store.filtered_list[i]} visible={props.visible} />
        )
      }
      return iReturn;
    } else {
      return (
        <div className="padd5">Ничего не найдено</div>
      )
    }
  };

  const scrollerMounted=()=>{
    // _scrollerRef
    const rect=_fakeInputRef.current.getBoundingClientRect();
    _scrollerRef.current.style.top=rect.top+rect.height-1+'px';
    _scrollerRef.current.style.left=rect.left+'px';
    _scrollerRef.current.style.width=rect.width+'px';
    console.log('rect',_scrollerRef.current.style, _scrollerRef.current);
  }

  const renderSelected=()=> {
    if(props.single) {
      console.log('props.linker.value',props.linker.value);
      if(props.linker.value) {
        return <TagInRow item={props.linker.value} deleteMe={() => {
          runInAction(() => {
            props.linker.value = null;
          });
        }}/>
      }
    } else {
      return props.linker.value.map((item, index) => {
        return <TagInRow item={item} key={index} deleteMe={() => {
          runInAction(() => {
            props.linker.value.splice(index, 1);
          });
        }}/>
      })
    }
    return null;

  }

  return (
    <div style={{}}>
      <div ref={_fakeInputRef} className={`hpadd5 ptop5 pr bg-w1 solid1 ${store.focused?"bo-pc1":"bo-w4"}`} onClick={()=>{ _inputRef.focus(); }} style={{cursor:"text", minHeight:40}}>
        {renderSelected()}

        <AutosizeInput
          onFocus={()=>{ onFocus();}}
          onBlur={()=>{ onBlur();}}
          onKeyDown={(e)=>{ keyDown(e); }}
          ref={(ref)=>{ _inputRef=ref; }}
          className={` noBorder pr mtop5 mbottom5`}
          {...input(store, 'input_value')}
        />
        {store.focused?(
          <Portal>
            <div ref={(ref)=>{
              _scrollerRef.current=ref;
              // _scrollerRef=ref;
              if(_scrollerRef.current) {
                // console.log('_scrollerRef, _scrollerRef.querySelector(".selected")', _scrollerRef, _scrollerRef.querySelector(".selected"));
                if(_scrollerRef.current.querySelector(".selected")) {
                  scrollToIfNotVisible(_scrollerRef.current, _scrollerRef.current.querySelector(".selected"))
                }
                scrollerMounted();
              }
            }} className="solid1 bo-pc1 pf ofa bg-w1 w100" style={{ zIndex:200000, maxHeight:150}}>
              {renderList()}
            </div>
          </Portal>
        ):null}
      </div>
    </div>
  )
};

Taglist.defaultProps = {};

Taglist.propTypes = {}

export default observer(Taglist);
